<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/order/ttPackageCollection";
export default {
  name: "ttPackageCollection",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [],
          methods: {},
        },
      },
      fields: [
        {
          name: () => this.$tz("揽收,单号"),
          key: "number",
          minWidth: 110,
        },
        {
          name: () => this.$tz("仓库名称"),
          key: "warehouse_name",
          minWidth: 110,
        },
        {
          name: () => this.$tz("揽收人"),
          key: "create_name",
          minWidth: 110,
        },
        {
          name: () => this.$tz("揽收,时间"),
          key: "create_time",
          minWidth: 110,
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>